<template>
  <v-container>
<!--    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>-->
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div style="min-height: 60vh">
      <AboutLayout1 v-if="form && form.template === 1 && showTemplate" />
      <AboutLayout2 v-if="form && form.template === 2 && showTemplate" />
    </div>
    <v-row id="about-expand" class="mt-3" >
      <v-col>
        <AboutExpandable mode="about" :state="routeHash && routeHash === '#network' ? 2:routeHash && routeHash === '#contact' ? 4:null" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const AboutLayout1 = () => import("./layout/AboutLayout1");
const AboutLayout2 = () => import("./layout/AboutLayout2");
import AboutExpandable from "../../components/expandables/AboutExpandable";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";

export default {
  components: {
    AboutLayout1,
    AboutLayout2,
    AboutExpandable,
    Loading
  },
  methods: {
    fullHandler() {
      this.visibleFull = true;
    }
  },
  computed:{
    ...mapState({
      form: state => {
        return state.About.form;
      },
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      tagName: state => state.Branch.tag_name,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    },
    routeHash: function () {
      return this.$route.hash;
    }
  },
  watch: {
    branchChanged: function() {
        this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
        )
      if (this.branchId === 0) {
          return this.$router.push(`/${this.lang}`+'/about-main');
      }
      this.isLoading = true;

        // console.log('see id', this.branchId);
      if (this.branchId === 5) {
          this.$store.dispatch('Branch/getMiniByBranch', { branch_id: this.branchId, lang: this.lang });
      }
      this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
      this.$store.dispatch("About/getAboutById",{
          id: this.branchId,
          lang: this.lang
      }).then(async res => {
          if (res.response_code === 200) {
              await this.$store.dispatch("About/setFormAbout", res.result);
              if (this.branchId === 5) {
                  // this.isLoading = false;
                  // this.$forceUpdate();
                  this.$router.push(`/${this.lang}`+`/mini-tcdc/about/mini-tcdc`);
              } else {
                  // this.isLoading = false;
                  // this.$forceUpdate();
                  for (const b of this.allBranches) {
                      if (res.result.branch_id === b.branch_id) {
                          this.isLoading = false;
                          this.$router.push(`/${this.lang}`+`/${b.tag_name}/about`).catch(()=>{});
                      }
                  }
              }
              this.showTemplate = false;
          } else {
              console.log('data not found');
          }
      }).then(() => {
          this.showTemplate = true
          this.isLoading = false;
      });

    },
    // form: function() {
    //   if (this.form && this.form.template === 3) {
    //     this.$router.push('/about/mini-tcdc/3');
    //   }
    // },
    routeHash: async function () {
      if (this.routeHash) {
        await new Promise(x => setTimeout(x, 1000));
        this.$vuetify.goTo('#about-expand');
      }
    }
  },
  async created() {
      let paramId = 0;
      if (this.allBranches.length === 0) {
          await this.$store.dispatch("Branch/getBranchAll");
      }
      for (const b of this.allBranches) {
          if (this.$route.params.branch === b.tag_name) {
              paramId = b.branch_id;
              break;
          }
      }
      if (this.$route.params.branch !== this.tagName) {
          this.$store.dispatch("About/getAboutById",{
              id: paramId,
              lang: this.lang
          }).then(res => {
              if (res.response_code == 200) {
                  this.$store.dispatch("About/setFormAbout", res.result);
              } else {
                  console.log('data not found');
              }
          });
          await this.$store.dispatch("Branch/getBranchById", paramId);
          await this.$store.dispatch("About/getAboutAllMenu", { branch_id: paramId, lang: this.lang });
      }
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
      this.$store.dispatch("About/getAboutById",{
        id: paramId,
        lang: this.lang
      }).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("About/setFormAbout", res.result);
        } else {
          console.log('data not found');
        }
      });
    // if (this.form && this.form.branch){
    //   this.items[0].text = this.form.branch.branch_name
    // }
  },
  async mounted() {
    if (this.routeHash) {
      await new Promise(x => setTimeout(x, 1000));
      this.$vuetify.goTo('#about-expand');
    }
  },
  data: () => ({
      showTemplate: true,
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/:branch"
      },
      {
        text: "ABOUT",
        to: '/about-main'
      }
    ],
    visibleFull: false,
    isLoading: false
  })
};
</script>

<style></style>
